export default "__VITE_ASSET__BQ3$ZbBO__"